import { setAppConfig as trSetAppConfig, getAppConfig as trGetAppConfig } from '@onviobr/app-information';
/**
 * Sets application configuration for current application
 * @public
 * @param config - Application configuration data
 */
export function setAppConfig(config) {
    var _a;
    trSetAppConfig({
        name: config.verticalName,
        version: config.version,
        attributes: {
            urlSeparator: (_a = config.urlSeparator) !== null && _a !== void 0 ? _a : '',
        },
    });
}
/**
 * Gets application configuration for current application
 * @public
 * @returns Application configuration data
 */
export function getAppConfig() {
    var _a;
    const trData = trGetAppConfig();
    return {
        verticalName: trData.name,
        version: trData.version,
        urlSeparator: (_a = trData.attributes) === null || _a === void 0 ? void 0 : _a.urlSeparator,
    };
}
